import { render, staticRenderFns } from "./orderEditorConfiguration.vue?vue&type=template&id=00b1c8b2&"
import script from "./orderEditorConfiguration.vue?vue&type=script&lang=js&"
export * from "./orderEditorConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports